import { RetriveUserModel } from "./product.interface";

export class NotificationDto {
    id: string;
    title: string;
    message: string;
    createdAt: string;
    type: NotificationDataType;
    topicIds: string[] | null;
    dataDetail: string | null;
    isRead: boolean;
    readAt: string | null;
    data: string | null;
    topicNames: string[] | null;
    dataType: NotificationDataType;

    static getNotiTargetUrl(noti: NotificationDto): string {
        if (noti.data) {
            let data = JSON.parse(noti.data);
            switch (Number(noti.dataType)) {
                case NotificationDataType.UpdateOrder:
                case NotificationDataType.NewOrder:
                case NotificationDataType.MissingStockOrder:
                    return 'account/my-order/' + encodeURIComponent(data.OrderId);
                case NotificationDataType.UpdateUser:
                    return 'account/profile';
                case NotificationDataType.Blog:
                default:
                    return data.url || '';
            }
        }
        return '';
    }
}
export enum NotificationDataType {
    NewUser = 1,
    NewOrder = 2,
    UpdateUser = 3,
    UpdateOrder = 4,
    Promotion = 5,
    MissingStockOrder = 6,
    NewAppUserLogin = 7,
    Blog = 8,
}

export enum NotificationStatusType {
    Actived = 1,
    Deleted = 99
}
export class NotificationRequestModel extends RetriveUserModel {

}